import * as React from "react";
import { Routes, Route } from "react-router-dom";
import { FvcAnalysisSetListScreen } from "./AnalysisSetsList/FvcAnalysisSetList";
import { SpirometryAnalysisScreen } from "./SpirometryAnalysisScreen";
import SpirometrySessionListScreen from "./SessionList/SpirometrySessionListScreen";
import { ActiveSpirometrySessionView } from "./Testing/ActiveSpirometrySessionView";
import { ChallengeOverreaderDecisionPanel } from "../Shared/ChallengeOverreaderDecisionPanel";
import { PermissionEnum } from "../../misc/api/ApiPermissionEnum";
import { PrivateRoute } from "../../Core/PrivateRoute";
import { ODataParams, SearchParams } from "../../Components/Query";

export const SpirometryRoot = () => {
    const [analysisSetListQuery, setAnalysisSetListQuery] = React.useState<SearchParams>();

    return (
        <Routes>
            <Route
                index
                element={
               <PrivateRoute permissions={[
                    PermissionEnum.AccessSingleFvcSession,
                    PermissionEnum.AccessAllFvcSessions,
                    PermissionEnum.OverreadFvcSession
                ]}>
                    <SpirometrySessionListScreen />
                </PrivateRoute>
                }
            />
            <Route path="Analysis"
            element={
                <PrivateRoute permissions={[
                   PermissionEnum.OverreadFvcSession
                ]}>
                <FvcAnalysisSetListScreen cachedQuery={analysisSetListQuery} setCachedQuery={setAnalysisSetListQuery} />
                    </PrivateRoute>
                }
            />
            <Route path="Analysis/:analysisSetId/:viewState"
             element={
               <PrivateRoute permissions={[
                    PermissionEnum.AccessSingleFvcSession,
                    PermissionEnum.OverreadFvcSession
               ]}>
                <SpirometryAnalysisScreen />
                    </PrivateRoute>
                }
            />
            <Route path="SiteAnalysis/:analysisSetId/:viewState"
                element={
               <PrivateRoute permissions={[
                    PermissionEnum.SiteReviewFvcSession
                      ]}>
                <ActiveSpirometrySessionView />
                    </PrivateRoute>
                }
            />
            <Route path=":analysisSetId/ChallengeDecision" element={
                <>
                    <SpirometrySessionListScreen />
                    <ChallengeOverreaderDecisionPanel />
                </>
            }/>
        </Routes>
    );
}
